export default "__VITE_ASSET__RGGu0vTh__"